import superagent from '@ott/superagent';

import { GeoPoint, ServerGeoPoint, ServerError } from '../types';
import extractError from './extractError';

const geoPointUrl = '/_bus/geo/get';

type Success = { data: ServerGeoPoint };
type Error = { error: ServerError };

const geoPointAdapter = (response: Success['data']): GeoPoint => {
  return {
    country: response.country,
    district: response.district,
    id: response.geopointId,
    name: response.name,
    region: response.region,
    translit: response.trnslt,
  };
};

const fetchGeoPointById = async (id: string) => {
  try {
    const response: GeoPoint = await superagent
      .get(geoPointUrl)
      .query({ id })
      .then((res: Response) => res.body)
      .then((res: Success | Error) => extractError<Success, Error>(res))
      .then(geoPointAdapter);

    return response;
  } catch {
    return null;
  }
};

export default fetchGeoPointById;
